import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { AlertGroupService } from '../_services';
import * as AlertGroupActions from '../_actions/alertGroup';

@Injectable({
  providedIn: 'root',
})
export class AlertGroupEffects {
  loadAlertGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AlertGroupActions.loadAlertGroups),
      mergeMap(() =>
        this.alertGroupService.getAlertGroups().pipe(
          map((alertGroups) => AlertGroupActions.loadAlertGroupsSuccess({ alertGroups })),
          catchError((error) => of(AlertGroupActions.loadAlertGroupsFailure({ error })))
        )
      )
    )
  );

  addAlertGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AlertGroupActions.addAlertGroup),
      mergeMap(({ alertGroup }) =>
        this.alertGroupService.saveAlertGroup(alertGroup).pipe(
          map((savedAlertGroup) =>
            AlertGroupActions.addAlertGroupSuccess({ alertGroup: savedAlertGroup })
          ),
          catchError((error) => of(AlertGroupActions.addAlertGroupFailure({ error })))
        )
      )
    )
  );

  updateAlertGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AlertGroupActions.updateAlertGroup),
      mergeMap(({ alertGroup }) =>
        this.alertGroupService.saveAlertGroup(alertGroup).pipe(
          map((updatedAlertGroup) =>
            AlertGroupActions.updateAlertGroupSuccess({ alertGroup: updatedAlertGroup })
          ),
          catchError((error) => of(AlertGroupActions.updateAlertGroupFailure({ error })))
        )
      )
    )
  );

  deleteAlertGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AlertGroupActions.deleteAlertGroup),
      mergeMap(({ id }) =>
        this.alertGroupService.deleteAlertGroup(id).pipe(
          map(() => AlertGroupActions.deleteAlertGroupSuccess({ id })),
          catchError((error) => of(AlertGroupActions.deleteAlertGroupFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private alertGroupService: AlertGroupService
  ) {}
}
